<template>
  <div>
    <h2 class="mb-[18px] text-[22px] font-medium leading-[26px] text-gray-800">
      Some updates you should know about
    </h2>
    <p class="text-[14px] leading-[22px] text-gray-800">
      We're updating our
      <a href="/legal/terms" class="text-link" target="_blank">Dacr Terms</a>,
      <a href="/legal/privacy" class="text-link" target="_blank">
        Privacy Policy</a
      >, and
      <a href="/legal/payments" class="text-link" target="_blank">
        Payments Policy</a
      >. Now's a great chance to review them.
    </p>
  </div>
</template>
